import { Alert } from "@mui/material";

const BillingExemptBanner = () => (
  <Alert severity="info" sx={{ mb: 2, fontWeight: 600, fontSize: 16 }}>
    Partner Program Access - Your account is currently provisioned under the
    Partner Trial Program. All features are fully unlocked for your evaluation
  </Alert>
);

export default BillingExemptBanner;
